export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.03156311,0,0,0.03156319,-1.3887768,-8.0260815)"
  >
    <path
      d="m 614.286,420.571 q 0,7.429 -5.714,13.143 L 342.286,700 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 49.714,433.714 Q 44,428 44,420.571 q 0,-7.429 5.714,-13.143 l 28.571,-28.571 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 L 329.142,603.428 553.713,378.857 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 l 28.571,28.571 q 5.714,5.714 5.714,13.143 z"
    />
  </g>
</svg>`;
